import React, { Fragment, useContext, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  CardContent,
  CardActions,
  CircularProgress,
  Button,
} from "@material-ui/core";
import { UsersData } from "src/ContextAPI";
import axios from "axios";
import Notify from "src/notification/Notify";

const TumorMakerEditForm = ({ info, close }) => {
  const { users } = useContext(UsersData);
  const [savebtnDisabled, setSavebtnDisabled] = useState(false);
  const [resultSubmitting, setResultSubmitting] = useState(false);

  const handleSaveResult = (e) => {
    e.preventDefault();
    e.persist();
    var formdata = new FormData(e.target);
    formdata.set("user_id", users.user_id);
    formdata.set("trace_number", info.data.trace_number);
    formdata.set("order_id", info.data.order_id);
    setResultSubmitting(true);
    axios
      .post("laboratory/tumor-maker/edit-result", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          Notify.successRequest("order result edit successful");
          close();
          setSavebtnDisabled(true);
        }
      })
      .catch((error) => {
        Notify.requestError(error);
      })
      .finally(() => setResultSubmitting(false));
  };

  return (
    <>
      <CardContent>
        <Fragment>
          <form onSubmit={handleSaveResult}>
            {info.ready && (
              <>
                <Box mb={3} hidden={!Boolean(parseInt(info.data.aso))}>
                  <Box display="flex">
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1">
                        <b> ASO </b>
                      </Typography>
                    </Box>
                  </Box>
                  <Box mt={1}>
                    <Box my={2}>
                      <TextField
                        label="Result"
                        fullWidth
                        name="aso_result"
                        variant="outlined"
                        multiline
                        defaultValue={
                          info.data.aso_result === null
                            ? ""
                            : info.data.aso_result
                        }
                      />
                    </Box>
                  </Box>
                </Box>

                <Box mb={3} hidden={!Boolean(parseInt(info.data.biopsy))}>
                  <Box display="flex">
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1">
                        <b> BIOPSY </b>
                      </Typography>
                    </Box>
                  </Box>

                  <Box mt={1}>
                    <Box my={2}>
                      <TextField
                        label="Result"
                        fullWidth
                        name="biopsy_result"
                        variant="outlined"
                        multiline
                        defaultValue={
                          info.data.biopsy_result === null
                            ? ""
                            : info.data.biopsy_result
                        }
                      />
                    </Box>
                  </Box>
                </Box>

                <Box mb={3} hidden={!Boolean(parseInt(info.data.c3))}>
                  <Box display="flex">
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1">
                        <b> C3 </b>
                      </Typography>
                    </Box>
                  </Box>

                  <Box mt={1}>
                    <Box my={2}>
                      <TextField
                        label="Result"
                        fullWidth
                        name="c3_result"
                        variant="outlined"
                        multiline
                        defaultValue={
                          info.data.c3_result === null
                            ? ""
                            : info.data.c3_result
                        }
                      />
                    </Box>
                  </Box>
                </Box>

                <Box mb={3} hidden={!Boolean(parseInt(info.data.ca_125))}>
                  <Box display="flex">
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1">
                        <b> CA 125 </b>
                      </Typography>
                    </Box>
                  </Box>

                  <Box mt={1}>
                    <Box my={2}>
                      <TextField
                        label="Result"
                        fullWidth
                        name="ca_125_result"
                        variant="outlined"
                        multiline
                        defaultValue={
                          info.data.ca_125_result === null
                            ? ""
                            : info.data.ca_125_result
                        }
                      />
                    </Box>
                  </Box>
                </Box>

                <Box mb={3} hidden={!Boolean(parseInt(info.data.cea))}>
                  <Box display="flex">
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1">
                        <b> CEA </b>
                      </Typography>
                    </Box>
                  </Box>

                  <Box mt={1}>
                    <Box my={2}>
                      <TextField
                        label="Result"
                        fullWidth
                        name="cea_result"
                        variant="outlined"
                        multiline
                        defaultValue={
                          info.data.cea_result === null
                            ? ""
                            : info.data.cea_result
                        }
                      />
                    </Box>
                  </Box>
                </Box>

                <Box mb={3} hidden={!Boolean(parseInt(info.data.psa_prostate))}>
                  <Box display="flex">
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1">
                        <b> PSA Prostate </b>
                      </Typography>
                    </Box>
                  </Box>

                  <Box mt={1}>
                    <Box my={2}>
                      <TextField
                        label="Result"
                        fullWidth
                        name="psa_prostate_result"
                        variant="outlined"
                        multiline
                        defaultValue={
                          info.data.psa_prostate_result === null
                            ? ""
                            : info.data.psa_prostate_result
                        }
                      />
                    </Box>
                  </Box>
                </Box>

                <Box hidden={!Boolean(parseInt(info.data.afp))}>
                  <Box display="flex">
                    <Box flexGrow={1}>
                      <Typography variant="subtitle1">
                        <b> AFP </b>
                      </Typography>
                    </Box>
                  </Box>

                  <Box mt={1}>
                    <Box my={2}>
                      <TextField
                        label="Result"
                        fullWidth
                        name="afp_result"
                        variant="outlined"
                        multiline
                        defaultValue={
                          info.data.afp_result === null
                            ? ""
                            : info.data.afp_result
                        }
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            )}

            <Box display="flex">
              <Box flexGrow={1} />
              <Box>
                <CardActions>
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    type="submit"
                    disabled={savebtnDisabled}
                    startIcon={
                      resultSubmitting && (
                        <CircularProgress size={20} color="inherit" />
                      )
                    }
                  >
                    Save Result
                  </Button>
                </CardActions>
              </Box>
            </Box>
          </form>
        </Fragment>
      </CardContent>
    </>
  );
};

export default TumorMakerEditForm;
